import createHistory from 'history/createBrowserHistory';

// react-router browser history
export default createHistory();



// WEBPACK FOOTER //
// ./src/core/store/history.ts